/**
 * {@link https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#pipe}
 */
export interface PrizmTextMaskPipeResult {
  value: string;

  indexesOfPipedChars?: readonly number[];
}
